import styled from 'styled-components'

export const ScrollableRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  margin-top: -10px;
  padding-top: 10px;
  margin-right: -24px;
  padding-right: 24px;

  overflow-x: scroll;
  overflow-y: hidden;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`
